// src/components/AiSuggestionCard.jsx
import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';

/**
 * Simple card that displays an AI‑generated suggestion with an optional "Apply" action.
 * Props:
 *   title   – short title for the suggestion
 *   detail  – longer description or markdown (rendered as plain text)
 *   onApply – callback when the user clicks Apply (may be null)
 */
export default function AiSuggestionCard({ title, detail, onApply }) {
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Box sx={{ mt: 1, mb: 2, whiteSpace: 'pre-wrap' }}>{detail}</Box>
        {onApply && (
          <Button size="small" variant="contained" onClick={onApply}>
            Apply
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
